export enum ADDITIONAL_TYPE {
  DEVICE_AUTH = 'H',
  SIMPLE = 'A',
  IDENTIFY = 'B',
  ARS = 'D',
  OVERSEAS_DEPARTURE = 'F',
  TRAN_PASSWORD = 'TP',
}
